var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(241, 242, 243)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 73.801,
    cy: 68.263,
    fill: "#ffffff",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 68.263,
    cy: 73.801,
    fill: "#e9e9e9",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.062s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 61.481,
    cy: 77.716,
    fill: "#d3d2d2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.125s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53.916,
    cy: 79.743,
    fill: "#918f90",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.187s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 46.084,
    cy: 79.743,
    fill: "#555555",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.25s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38.519,
    cy: 77.716,
    fill: "#333333",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.312s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 31.737,
    cy: 73.801,
    fill: "#111111",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.375s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26.199,
    cy: 68.263,
    fill: "#000000",
    r: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.437s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;0 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.0d3fcb8be4e1b447cc93505ec69c23ff.svg";
export { ForwardRef as ReactComponent };